import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from "../../../api/api";

const AdsCreate = () => {
  const { register, handleSubmit, unregister } = useForm();

  const handleSub = (data) => {
    const formData = new FormData();
    formData.append('title', data.title)
    formData.append('type', data.type)
    formData.append('image', data.image[0])
    formData.append('is_active', data.is_active)


    api
    .post('/advertisement/', formData)
    .then((response)=> {
      console.log(response.data)
      toast.success("Advertisement created succesfully")
    }).catch(error=> {
      console.log(error)
      toast.error(error)
    })


  }

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Ads
      </h1>

       <form className="ml-5 mt-5" onSubmit={handleSubmit(handleSub)}>
       <div className="grid md:grid-cols-2">
        <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
          <label className="text-primary-red">Title</label>
          <input type="text" placeholder="Title" className="outline-none"
          {...register("title", { required: false })}
          />
        </div>

        <div className="border-primary-blue  border-l-0 flex items-center gap-2 border-2 p-2">
          <label className="text-primary-red ">Image</label>
          <input type="file"  className="w-[70%] text-sm"
          {...register("image", { required: false })}
          />
        </div>

        <div className="border-primary-blue flex items-center gap-2 border-2 p-2 border-t-0">
          <label className="text-primary-red">Type</label>
          {/* <input type="text" placeholder="Type" className="border border-gray-500" /> */}
          <select name="type" id='type'
          {...register("type", { required: false })}
          >
             <option value="horizontal">Horizontal</option>
             <option value="vertical">Vertical</option>
             <option value="square">Square</option>
          </select>
        </div>
        <div className="border-primary-blue border-t-0 flex items-center gap-2 border-2 p-2  md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Action:
              </label>
              <label className="text-primary-blue" htmlFor="">
                Show
              </label>
              <input
                type="radio"
                // name="action"
                value={true}
                {...register("is_active", { required: false })}
                
                className="py-2 px-2 outline-none"
              />
              <label className="text-primary-blue" htmlFor="">
                Hide
              </label>
              <input
                type="radio"
                name="action"
                value= {false}
                {...register("is_active", { required: false })}
                className="py-2 px-2 outline-none"
              />
            </div>
        </div>
        
        <div>
          {/* <button type="submit">
            Submit
          </button> */}
          <button 
          className="bg-primary-green ml-10 mt-5 inline-flex gap-2 rounded-md px-4 py-2 font-bold text-white"
        >
          Save
        </button>
        </div>
      </form> 
    </div>
  );
};

export default AdsCreate;
